var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnassignedCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#666E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15C16.9319 15 15.25 16.6819 15.25 18.75C15.25 20.8181 16.9319 22.5 19 22.5C21.0681 22.5 22.75 20.8181 22.75 18.75C22.75 16.6819 21.0681 15 19 15ZM21.5 18.75C21.5 19.2125 21.365 19.64 21.1456 20.0119L17.7381 16.6038C18.11 16.3844 18.5375 16.2494 19 16.2494C20.3787 16.2494 21.5 17.3713 21.5 18.75ZM16.5 18.75C16.5 18.2875 16.635 17.86 16.8544 17.4881L20.2619 20.8962C19.89 21.1156 19.4625 21.2506 19 21.2506C17.6213 21.2506 16.5 20.1287 16.5 18.75ZM13.375 15C15.4431 15 17.125 13.3181 17.125 11.25C17.125 9.18187 15.4431 7.5 13.375 7.5C11.3069 7.5 9.625 9.18187 9.625 11.25C9.625 13.3181 11.3069 15 13.375 15ZM15.7006 22.5H8.375C8.02938 22.5 7.75 22.22 7.75 21.875C7.75 18.7738 10.2731 16.25 13.375 16.25C13.7937 16.25 14.2006 16.2994 14.5938 16.3869C14.2156 17.0906 14 17.895 14 18.75C14 20.2456 14.66 21.5837 15.7006 22.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedCard);
export default __webpack_public_path__ + "static/media/UnassignedCard.dc383027985ffbaf60378bdc011029ec.svg";
export { ForwardRef as ReactComponent };